// src/pages/Logout.js
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout as reduxLogout } from '../redux/actions/authActions';
import { useAuth } from '../context/AuthContext';

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { logout: authLogout } = useAuth();

  useEffect(() => {
    // Clear all auth data
    authLogout();
    dispatch(reduxLogout());
    
    // Redirect to login
    navigate('/', { replace: true });
  }, [dispatch, navigate, authLogout]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Logging out...</p>
      </div>
    </div>
  );
};

export default Logout;